import { Box, Flex, Image, Text } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';
import Heading from 'components/_core/Heading';

export const BorderedBox: FCWithChildren<React.ComponentProps<typeof Flex>> = ({
  children,
  ...props
}) => {
  return (
    <Flex
      border="1px solid"
      borderColor="grey.300"
      borderRadius="radius-16"
      {...props}
    >
      {children}
    </Flex>
  );
};

export function LargeEmptyState({
  description,
  headingProps = {},
  image,
  title,
  ...props
}: {
  title: string;
  description?: string;
  image: string;
  headingProps?: React.ComponentProps<typeof Heading>;
} & React.ComponentProps<typeof BorderedBox>) {
  return (
    <BorderedBox
      alignItems="center"
      backgroundColor="white"
      border="1px solid"
      borderColor="grey.300"
      borderRadius="radius-8"
      flexDirection="column"
      gap="32"
      justifyContent="center"
      padding="space-32"
      {...props}
    >
      <Box>
        <Image maxWidth="90px" src={image} />
      </Box>

      <Box>
        <Heading textAlign="center" {...headingProps}>
          {title}
        </Heading>
        <Text textAlign="center">{description}</Text>
      </Box>
    </BorderedBox>
  );
}
